import React, {useContext, useEffect, useRef, useState} from 'react';
import {CitizenContext} from "../context/citizen-context.jsx";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
import Button from "../../../../../../components/button/button.jsx";
import {IoMdClose} from "react-icons/io";
import InputCheckbox from "../../../../../../components/input/input-checkbox.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import {MaskDefault} from "../../../../../../utils/mask.js";
import {FaTriangleExclamation} from "react-icons/fa6";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import protectionType from "../../utils/protection-type.js";
import AggressorRestriction from "../../utils/aggressor-restriction.js";
import ViolenceType from "../../utils/violence-type.js";
import {getCities, getCountries} from "../../../../../../utils/location-utils.js";
import optionsUtils from "../../../../../../utils/options-utils.js";
import InputDateTime from "../../../../../../components/input/input-datetime.jsx";
import InputTextarea from "../../../../../../components/input/input-textarea.jsx";
import CitizenGeneralAddress from "./citizen-general-address.jsx";
import CitizenGeneralVehicles from "./citizen-general-vehicles.jsx";
import citizenService from "../../../../../../services/web/citizen-service.js";
import {Modal} from "../../../../../../components/modal/modal.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import {Card} from "../../../../../../components/card/card.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import moment from "moment";
import {FaTrash} from "react-icons/fa";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";
import individualService from "../../../../../../services/web/individual-service.js";
import {format} from "date-fns";
import readImageFile from "../utils/read-image-file.js";
import AggressorSubpoena from "../../utils/aggressor-subpoena.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const CitizenAggressor = ({aggressorSelected, setAggressorSelected, setTabSelected}) => {
    const {id, aggressors, setAggressors, setAttaches, fetchData} = useContext(CitizenContext);
    const aggressor = aggressors.find(a => a.id === aggressorSelected);

    const navigate = navigateHook();

    const [citizens, setCitizens] = useState([]);
    const [citizensModal, setCitizensModal] = useState(false);

    const gridRef = useRef(undefined);
    const imgRef = useRef(undefined);

    const [columnCitizensDefs,] = useState([
        {field: "name", headerName: "Nome", flex: 2},
        {field: "", headerName: "CPF/CPNJ", valueFormatter: ({data: {cpf, cnpj}}) => cpf ? projectUtils.formatCpfToView(cpf) : projectUtils.formatCnpjToView(cnpj)},
        {field: "protectionProgram", headerName: "Programa de proteção", flex: 1, valueFormatter: ({value}) => value?.map(i => i.name).join(", ")},
        {field: "registrationDt", headerName: "Data/hora do cadastro", flex: 1, valueFormatter: ({value}) => moment(value).format("DD/MM/YYYY HH:mm")},
    ]);

    useEffect(() => {
        if (!aggressorSelected) return;
        if (aggressor?.cpf) citizensByAggressor(aggressor.cpf);
        else setCitizens([])
    }, [aggressorSelected]);

    useEffect(() => {
        const cpfClear = aggressor?.cpf?.replace(/\D/g, '');
        if (!cpfClear || cpfClear.length < 11) {
            setCitizens([]);
            return;
        }

        const timer = setTimeout(() => {
            citizensByAggressor(cpfClear);
            searchIndividualByCpf(cpfClear);
        }, 400);

        return () => clearTimeout(timer);
    }, [aggressor?.cpf]);


    const handleInput = ({target: {id, value}}) => updateAggressor({ [id]: value });

    const handleDateInput = (id, value) => {
        const dateFormated = value ? format(value, "yyyy-MM-dd") : null
        if (aggressor[id] === dateFormated) return
        console.log(aggressor[id], dateFormated)

        updateAggressor({[id]: value});
    }

    const handleItemChecked = ({target: {id, checked}}) => updateAggressor({ [id]: checked });

    const handleArrayItems = (value, target) => updateAggressor({ [target]: value });

    const handleSelectItems = (value, target, secondTarget) => {
        const updates = { [target]: value?.value };
        if (secondTarget) updates[secondTarget] = value?.label;

        updateAggressor(updates);
    }

    const citizensByAggressor = (cpf) => {
        const cpfClear = cpf?.replaceAll(".", "")?.replace("-", "");
        if (cpfClear.length < 11) {
            setCitizens([]);
            return;
        }

        citizenService.getCitizensByAggressor(cpfClear, id ?? "-1").then(data => setCitizens(data)).catch(() => setCitizens([]));
    }

    const searchIndividualByCpf = (cpf) => {
        const cpfClear = cpf?.replaceAll(".", "")?.replace("-", "");
        if (cpfClear.length < 11) {
            setCitizens([]);
            return;
        }

        individualService.get(cpfClear).then(({data}) => {
            if (!data) return;

            const dataParse = JSON.parse(data.data);

            updateAggressor({
                name: dataParse.name,
                socialName: dataParse.socialName,
                dtBirth: dataParse.dtBirthRaw,
                nationality: dataParse.nationality,
                cityBirth: dataParse.cityOfBirth
            })
        });
    }

    const attachAggressorImage = ({target: {files}}) => {
        readImageFile(files, (file, imgScr) => {
            setAttaches(prev => [
                ...prev.filter(i => i.attachId !== aggressor?.attachId),
                file
            ]);
            updateAggressor({file, imgScr, attachId: file.attachId});
        });
    }

    const removeFile = () => {
        setAttaches(prev => prev.filter(i => i.attachId !== aggressor?.attachId));
        updateAggressor({file: undefined, imgScr: undefined, attachId: null});
    }

    const updateAggressor = (updates) => {
        setAggressors(prev => {
            const index = prev.findIndex(a => a.id === aggressorSelected);
            if (index === -1) return prev;

            const next = [...prev];

            next[index] = { ...next[index], ...updates };

            return next;
        });
    };

    const removeAggressor = () => {
        setAttaches(prev => prev.filter(i => i.attachId !== aggressor.attachId));
        setAggressors(prev => prev.filter(i => i.id !== aggressorSelected));

        setAggressorSelected(null);
        setTabSelected("general");
    }

    return (
        <article className={"space-y-3"}>
            <Card>
                <Card.Header className={"!justify-between"}>
                    <Card.Title>Dados do Agressor</Card.Title>

                    <Button target={"danger"} onClick={removeAggressor}>
                        <FaTrash />
                    </Button>
                </Card.Header>
                <Card.Body className={"grid grid-cols-12 gap-4"}>
                    <section className={"col-span-3"}>
                        <div className={"h-[137px]"}>
                            <div
                                className={"cursor-pointer bg-no-repeat bg-contain h-full border border-[#e0e0e0] p-1 rounded"}
                                style={{backgroundImage: (!aggressor?.imgScr && aggressor?.attachId) ? `url(${API_KEEPER}/ged/attach/${aggressor?.attachId})` : aggressor?.imgScr ? `url(${aggressor?.imgScr})` : `url(${getAssetPath("img/user.png")})`, backgroundPosition: "50% center"}}
                            >
                                {
                                    aggressor?.attachId &&
                                    <Button className={"remove-image float-right"} target={"danger"} title={"Remover imagem"} onClick={removeFile}>
                                        <IoMdClose className={"remove-image"}/>
                                    </Button>
                                }
                            </div>
                        </div>
                        <input type="file" accept="image/png, image/jpeg" className="hidden" name="image" onChange={attachAggressorImage} ref={imgRef}/>
                        <Button className={"w-full"} target={"primary"} onClick={() => imgRef.current?.click()}>
                            Selecionar foto
                        </Button>
                    </section>
                    <section className={"col-span-9 grid grid-cols-12 gap-4"}>
                        <InputForm
                            id={"name"}
                            label={"Nome *"}
                            classNameWrapper={"col-span-5"}
                            value={aggressor?.name ?? ""}
                            onChange={handleInput}
                        />

                        <InputForm
                            id={"socialName"}
                            label={"Nome social"}
                            classNameWrapper={"col-span-3"}
                            value={aggressor?.socialName ?? ""}
                            onChange={handleInput}
                        />

                        <div className={"col-span-4 flex flex-row gap-2"}>
                            <InputForm
                                id={"cpf"}
                                label={"CPF"}
                                value={aggressor?.cpf ?? ""}
                                classNameWrapper={"w-full"}
                                onChange={handleInput}
                                title={"Cadastros associados ao agressor"}
                                mask={MaskDefault.cpf}
                            />

                            <Button
                                className={!citizens.length ? "bg-[#9B9B9B]! cursor-default opacity-70" : ""}
                                onClick={() => {
                                    if (!citizens?.length) return
                                    setCitizensModal(true)
                                }}
                                title={!citizens.length ? "Nenhum cadastro associado" : "Cadastros associados ao agressor"}
                            >
                                <FaTriangleExclamation />
                            </Button>
                        </div>

                        <InputDateTime
                            id={"dtBirth"}
                            label={"Nascimento"}
                            dateFormat="L"
                            classNameWrapper={"col-span-3"}
                            selected={aggressor?.dtBirth}
                            onChange={(date) => handleDateInput("dtBirth", date)}
                        />

                        <SelectComponent
                            classNameWrapper={"col-span-3"}
                            loadOptions={getCountries}
                            value={optionsUtils.getValue(aggressor?.nationality)}
                            isAsync={true}
                            label="Nacionalidade"
                            onChange={(value) => handleSelectItems(value, "nationality")}
                            cacheOptions
                            defaultOptions={[]}
                        />

                        <SelectComponent
                            classNameWrapper={"col-span-3"}
                            loadOptions={getCities}
                            value={optionsUtils.getValue(aggressor?.cityBirth)}
                            isAsync={true}
                            label="Naturalidade"
                            onChange={(value) => handleSelectItems(value, "cityBirth")}
                            cacheOptions
                            defaultOptions={[]}
                        />

                        <SelectComponent
                            classNameWrapper={"col-span-3"}
                            value={aggressor?.educationId}
                            options={fetchData.educations}
                            label={"Escolaridade"}
                            onChange={(value) => handleSelectItems(value, "educationId", "education")}
                        />

                        <SelectComponent
                            classNameWrapper={"col-span-4"}
                            value={aggressor?.protectionType}
                            options={protectionType.getProtectionTypes()}
                            label={"Tipo de medida *"}
                            onChange={(value) => handleSelectItems(value, "protectionType")}
                        />

                        <SelectComponent
                            classNameWrapper={"col-span-4"}
                            value={aggressor?.familyConnectionId}
                            options={fetchData.familyConnections}
                            label={"Vínculo com o protegido"}
                            onChange={(value) => handleSelectItems(value, "familyConnectionId", "familyConnection")}
                        />

                        <InputCheckbox
                            id={"livesWithProtected"}
                            className={"col-span-4 self-center"}
                            checked={!!aggressor?.livesWithProtected}
                            onChange={handleItemChecked}
                            label={"Mora com o protegido"}
                        />

                        <SelectComponent
                            classNameWrapper={"col-span-4"}
                            value={aggressor?.violenceTypes ?? []}
                            options={ViolenceType.options}
                            label={"Tipo de violência"}
                            onChange={(value) => updateAggressor({ violenceTypes: value })}
                            isMulti
                        />

                        <InputCheckbox
                            id={"firearmUseHistory"}
                            className={"col-span-4 self-center"}
                            checked={!!aggressor?.firearmUseHistory}
                            onChange={handleItemChecked}
                            label={"Histórico de uso de arma de fogo"}
                        />

                        <InputCheckbox
                            id={"reflectiveGroup"}
                            className={"col-span-4 self-center"}
                            checked={!!aggressor?.reflectiveGroup}
                            onChange={handleItemChecked}
                            label={"Participa de Grupo Reflexivo"}
                        />
                    </section>

                    <InputForm
                        id={"processNumber"}
                        label={"Número do processo"}
                        classNameWrapper={"col-span-3"}
                        value={aggressor?.processNumber ?? ""}
                        onChange={handleInput}
                    />

                    <InputDateTime
                        id={"dtExpedition"}
                        label={"Data de expedição"}
                        dateFormat="L"
                        classNameWrapper={"col-span-3"}
                        selected={aggressor?.dtExpedition}
                        onChange={(date) => handleDateInput("dtExpedition", date)}
                    />

                    <InputDateTime
                        id={"dtExpiration"}
                        label={"Data de expiração"}
                        dateFormat="L"
                        classNameWrapper={"col-span-3"}
                        selected={aggressor?.dtExpiration}
                        disabled={aggressor?.hasNoExpiration}
                        onChange={(date) => handleDateInput("dtExpiration", date)}
                    />

                    <InputCheckbox
                        id={"hasNoExpiration"}
                        className={"col-span-3 self-center"}
                        disabled={!!aggressor?.dtExpiration}
                        checked={!!aggressor?.hasNoExpiration}
                        onChange={handleItemChecked}
                        label={"Prazo Indeterminado"}
                    />

                    <InputForm
                        id={"minDistance"}
                        label={"Distanciamento (metros)"}
                        classNameWrapper={"col-span-3"}
                        value={aggressor?.minDistance ?? ""}
                        type={"number"}
                        onChange={handleInput}
                    />

                    <InputForm
                        id={"criminalCourt"}
                        label={"Vara criminalista"}
                        classNameWrapper={"col-span-3"}
                        value={aggressor?.criminalCourt ?? ""}
                        onChange={handleInput}
                    />

                    <SelectComponent
                        classNameWrapper={"col-span-3"}
                        value={aggressor?.subpoena}
                        options={AggressorSubpoena.options}
                        label={"Mandado de Intimação"}
                        onChange={(value) => updateAggressor({ subpoena: value })}
                    />

                    <InputCheckbox
                        id={"arrestWarrant"}
                        className={"col-span-3 self-center"}
                        checked={!!aggressor?.arrestWarrant}
                        onChange={handleItemChecked}
                        label={"Mandado de Prisão"}
                    />

                    <SelectComponent
                        classNameWrapper={"col-span-full"}
                        value={aggressor?.restrictions ?? []}
                        options={AggressorRestriction.options}
                        label={"Restrições do agressor"}
                        onChange={(value) => updateAggressor({ restrictions: value })}
                        isMulti
                    />

                    <InputTextarea
                        id={"aggressor-description"}
                        className={"col-span-full"}
                        textAreaClass={"h-20"}
                        label={"Informações adicionais"}
                        value={aggressor?.description ?? ""}
                        onChange={({target: {value}}) => updateAggressor({ description: value })}
                    />
                </Card.Body>
            </Card>

            <CitizenGeneralAddress
                title={"Endereços do agressor"}
                addresses={aggressor?.addresses ?? []}
                onChange={(value) => handleArrayItems(value, "addresses")}
            />

            <CitizenGeneralVehicles
                title={"Veículos do agressor"}
                vehicles={aggressor?.vehicles ?? []}
                onChange={(value) => handleArrayItems(value, "vehicles")}
            />

            <Modal open={citizensModal} setOpen={setCitizensModal} title={"Cadastros associados ao agressor"}>
                <Modal.Body className={"!mt-0 p-4"}>
                    <div className={"ag-theme-quartz grid"} style={{height: "calc(100vh - 245px)"}}>
                        <AgGridReact
                            ref={gridRef}
                            rowHeight={35}
                            rowData={citizens}
                            columnDefs={columnCitizensDefs}
                            paginationAutoPageSize={true}
                            pagination={true}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme()}
                            onCellClicked={({data}) => navigate(`/sos/citizens/form/${data.id}`, true)}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </article>
    );
};

export default CitizenAggressor;